var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('data-viz-mobile-toggle-button');
import { ChevronDownIconGlyph } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { Icon } from './icon';
export var DataVizMobileToggleButtonDefaultProps = {
  isExpanded: false,
  label: 'Show Map'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    flex-direction: row;\n    font-weight: 400;\n    padding: ", " ", " ", ";\n    font-family: ", ";\n    justify-content: space-between;\n    font-size: ", ";\n    color: ", ";\n    background: ", ";\n    color: ", ";\n\n\n    &:hover {\n      color: ", ";\n      ", " {\n        ", ";\n      }\n    }\n\n  "], ["\n    ", ";\n    ", ";\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    flex-direction: row;\n    font-weight: 400;\n    padding: ", " ", " ", ";\n    font-family: ", ";\n    justify-content: space-between;\n    font-size: ", ";\n    color: ", ";\n    background: ", ";\n    color: ", ";\n\n\n    &:hover {\n      color: ", ";\n      ", " {\n        ", ";\n      }\n    }\n\n  "])), theme.TRANSITION('color'), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(2), theme.UNIT(3, 2), theme.UNIT(2, 2), theme.FONT('sans'), theme.FONT_SIZE(13), theme.COLOR('sub'), theme.COLOR('bright-warm'), theme.COLOR('sub'), theme.COLOR('strong'), cls.child('icon'), theme.FILL('strong'))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 48px;\n    height: 48px;\n  "], ["\n    width: 48px;\n    height: 48px;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-transform: uppercase;\n    color: inherit;\n  "], ["\n    text-transform: uppercase;\n    color: inherit;\n  "])))
});
var ToggleLabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-transform: uppercase;\n    color: inherit;\n  "], ["\n    text-transform: uppercase;\n    color: inherit;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    margin-right: ", ";\n    ", "\n  "], ["\n    ", ";\n    ", ";\n    margin-right: ", ";\n    ", "\n  "])), theme.TRANSITION('transform'), theme.FILL('subtle'), theme.UNIT(1), function (_a) {
    var isExpanded = _a.isExpanded;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      transform: rotate(", "deg);\n    "], ["\n      transform: rotate(", "deg);\n    "])), isExpanded ? 180 : 0);
  })
});
var StartStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var EndStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    gap: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    gap: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "])), theme.UNIT(3))
});
var IconContainerStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: 48px;\n  "], ["\n    height: 48px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Start: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  Label: styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Image: styled.img(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  IconContainer: styled(Icon)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IconContainerStyles),
  End: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), EndStyles),
  ToggleLabel: styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ToggleLabelStyles),
  Icon: styled(ChevronDownIconGlyph).attrs(cls.attr('icon'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var DataVizMobileToggleButton = function (props) {
  var className = props.className,
    isExpanded = props.isExpanded,
    onClick = props.onClick,
    label = props.label,
    image = props.image,
    icon = props.icon;
  var t = useLang();
  var hasImage = !!image;
  var Icon = icon;
  var toggleLabel = props.isExpanded ? t('Hide') : t('Show');
  var handleClick = onClick && function () {
    onClick();
  };
  return React.createElement(My.Container, {
    onClick: handleClick,
    className: cls.name(className)
  }, React.createElement(My.Start, null, hasImage ? React.createElement(My.Image, {
    src: image
  }) : React.createElement(My.IconContainer, {
    size: 32
  }, React.createElement(Icon, null)), React.createElement(My.Label, null, t(label))), React.createElement(My.End, null, React.createElement(My.Label, null, toggleLabel), React.createElement(My.Icon, {
    isExpanded: isExpanded,
    size: 16
  })));
};
DataVizMobileToggleButton.cls = cls;
DataVizMobileToggleButton.defaultProps = DataVizMobileToggleButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;